import { Component } from '@angular/core';
import { NavItemComponent } from '../nav-item.component';
import { NavItemViewModel } from '../nav-item-view-model';

@Component({
  selector: 'app-sign-out-nav-item',
  templateUrl: './sign-out-nav-item.component.html',
  styleUrls: ['./sign-out-nav-item.component.scss', '../nav-item.component.scss'],
  providers: [NavItemViewModel]
})
export class SignOutNavItemComponent extends NavItemComponent {
  public navItemSelected(): void {
    this.router.navigate([`/auth/sign-out`]).then();
  }
}
